var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('NotificationsPool'),(this.$route.path !== '/login')?_c('MainContent'):_vm._e(),(this.$route.path === '/login')?_c('Login'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }